import type { ModuleCardProps } from '@/types/landing.types'
import { getModuleIconImage } from '@/utils/landing/moduleUtils'

export default function ModuleCard({
  icon,
  title,
  color,
  notifications = 0,
  onClick,
  className = ''
}: ModuleCardProps) {
  // Utiliser l'icône directement si c'est une image (string path), sinon utiliser getModuleIconImage
  const iconSrc = typeof icon === 'string' && (icon.endsWith('.png') || icon.endsWith('.jpg') || icon.endsWith('.svg') || icon.startsWith('/') || icon.startsWith('http'))
    ? icon
    : getModuleIconImage(color)

  return (
    <div
      className={`
        flex flex-col items-center justify-center text-center cursor-pointer 
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 group
        ${className}
      `}
      onClick={onClick}
    >
      {/* Icon Container avec badge de notification */}
      <div className="relative mb-2">
        {/* Icon - image 3D sans background coloré */}
        <div className="
          w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14
          flex items-center justify-center
          transition-all duration-300 ease-out
          group-hover:scale-110
        ">
          <img 
            src={iconSrc} 
            alt={title}
            className="w-full h-full object-contain"
          />
        </div>

        {/* Notification Badge - collé à l'icône style iOS */}
        {notifications > 0 && (
          <div className="
            absolute -top-1 -right-1 w-5 h-5 rounded-full 
            flex items-center justify-center text-xs font-semibold text-white z-20 
            bg-red-500 border-2 border-white shadow-sm
          ">
            {notifications > 99 ? '99+' : notifications}
          </div>
        )}
      </div>

      {/* Title - style iOS simple */}
      <h3 className="
        text-xs md:text-sm lg:text-sm font-medium text-gray-800
        leading-tight
      ">
        {title}
      </h3>
    </div>
  )
}

